import { useToast } from "@chakra-ui/react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ClinicaService } from "@/services/ADM/ClinicaService";

// ── Queries ───────────────────────────────────────────────────────────────────

export const useClinicasComFiliais = () =>
  useQuery({
    queryKey: ["clinicasComFiliais"],
    queryFn: () => ClinicaService.getAllClinicasComFiliais(),
  });

// ── Mutations ─────────────────────────────────────────────────────────────────

export const useCreateClinica = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (data) => ClinicaService.create(data),
    onSuccess: (data) => {
      const { message } = data
      queryClient.invalidateQueries(["clinicasComFiliais"]);
      toast({
        title: "Sucesso",
        description: message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro",
        description: error.message || "Falha ao cadastrar clínica.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};

export const useUpdateClinica = (id) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (data) => ClinicaService.update(id, data),
    onSuccess: (data) => {
      const { message } = data
      queryClient.invalidateQueries(["clinicasComFiliais"]);
      toast({
        title: "Sucesso",
        description: message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro",
        description: error.message || "Falha ao atualizar clínica.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};

export const useDeleteClinica = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (data) => ClinicaService.removeClinica(data),
    onSuccess: (data) => {
      const { message } = data
      queryClient.invalidateQueries({ queryKey: ["clinicasComFiliais"] });
      toast({
        title: "Sucesso",
        description: message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro",
        description: error.message || "Falha ao excluir clínica.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};

export const useCreateFilial = (clinicaId) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (data) => ClinicaService.createFilial(clinicaId, data),
    onSuccess: (response) => {
      const { message } = response;
      queryClient.invalidateQueries(["clinicasComFiliais"]);
      toast({
        title: "Sucesso",
        description: message || "Filial cadastrada com sucesso.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro",
        description: error.message || "Falha ao cadastrar filial.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};

export const useUpdateFilial = (filialId) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (data) => ClinicaService.updateFilial(filialId, data),
    onSuccess: (data) => {
      const { message, } = data;
      queryClient.invalidateQueries(["clinicasComFiliais"]);
      toast({
        title: "Sucesso",
        description: message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro",
        description: error.message || "Falha ao atualizar filial.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};

export const useDeleteFilial = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (data) => ClinicaService.removeFilial(data),
    onSuccess: (data) => {
      const { message } = data;
      queryClient.invalidateQueries(["clinicasComFiliais"]);

      toast({
        title: "Sucesso",
        description: message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro",
        description: error.message || "Falha ao excluir filial.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};
